import type { ReactNode } from 'react';
import { CollapsedBin } from '../../components/ui/collapsed-bin';
import { IMPORT_CHANGE_WHAT_THEY_BECOME } from '../../lib/copy';

/**
 * **An attendee list folds its record choices** (owner's ruling, 2026-10-24):
 * the levels table on the Plan tab and the bulk row on the People tab. Nearly
 * every list keeps their defaults, and they led pages whose question for an
 * event upload is which event; any other import shows them open.
 */
export function EventFold({ folded, children }: { folded: boolean; children: ReactNode }) {
  return folded ? (
    <CollapsedBin label={IMPORT_CHANGE_WHAT_THEY_BECOME}>{children}</CollapsedBin>
  ) : (
    <>{children}</>
  );
}
